export function formatTimestamp(timestamp) {
    let date = new Date(timestamp);
    let day = date.getDate().toString().padStart(2, '0'); 
    let month = (date.getMonth() + 1).toString().padStart(2, '0'); 
    let year = date.getFullYear();
    let hours = date.getHours().toString().padStart(2, '0');
    let minutes = date.getMinutes().toString().padStart(2, '0');
    let seconds = date.getSeconds().toString().padStart(2, '0');
    let formattedDate = `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;

    return formattedDate;
}

export const formatDate = (dateString) => {
    const date = new Date(dateString);
    const dateCame = date.toISOString().split('T')[0];
    const [year, month, day] = dateCame.split('-');
          return `${day}-${month}-${year}`;
  };
export const convertDateFormat = (dateString) => {
    const [year, month, day] = dateString.split('-');
    return `${day}-${month}-${year}`;
};

export const Nft113names = [
    "DATE",
    "NFTN50",
    "NFT100",
    "NFT200",
    "NFTTTLMAR",
    "NFT500",
    "NFT500MC50_25_25",
    "NFT500LGMSEQLCAPWTD",
    "NFT50",
    "NFTMC150",
    "NFTMC50",
    "NFTMCSEL",
    "NFTMC100",
    "NFTSC250",
    "NFTSC50",
    "NFTFSC100",
    "NFTMC250",
    "NFTLMC250",
    "NFTMSC400",
    "NFT100EQLWGT",
    "NFT100LVLT30",
    "NFT50A",
    "NFT50FPR",
    "NFT50FTR",
    "NFT200MOM30",
    "NFT200AL30",
    "NFT100AL30",
    "NFTAL50",
    "NFTALVLT30",
    "NFTAQLTLVLT30",
    "NFTAQLTVLLVLT30",
    "NFTDO50",
    "NFTGRTHSEC15",
    "NFTHBETA50",
    "NFTLVLT50",
    "NFTT10EQLWGT",
    "NFT100QLT30",
    "NFTMC150MOM50",
    "NFT500MOM50",
    "NFTMC150QLT50",
    "NFTSC250QLT50",
    "NFTMSC400MOMQLT100",
    "NFTSC250MOMQLT100",
    "NFTQLTLVLT30",
    "NFT50DIVPNT",
    "NFT50EW",
    "NFT50PR1XINVS",
    "NFT50PR2XLVG",
    "NFT50TR1XINVS",
    "NFT50TR2XLVG",
    "NFT50VL20",
    "NFT200VL30",
    "NFT500VL50",
    "NFT500EQLWGT",
    "NFT200QLT30",
    "NFT50SRTDURDEBTDYNP_B",
    "NFT50SRTDURDEBTDYNP_E",
    "NFTEQTSAV",
    "NFTCORPGRPIABG",
    "NFTCOMM",
    "NFTCH",
    "NFTCPSE",
    "NFTENG",
    "NFTEVNAAMT",
    "NFTHOUS",
    "NFT100ESG",
    "NFT100EESG",
    "NFT100ESGSL",
    "NFTCONS",
    "NFTDEF",
    "NFTINDDIG",
    "NFTINDMFG",
    "NFTINDTR",
    "NFTINFS",
    "NFTINDCORPGRPIMG",
    "NFTMCL15",
    "NFTMSINDCON",
    "NFTMNC",
    "NFTMOB",
    "NFTPSE",
    "NFTRI",
    "NFTNCC",
    "NFTSERSEC",
    "NFTSH25",
    "NFTINDCORPGRPITG",
    "NFTINDCORPGRPITG25PC",
    "NFTTRANSLOG",
    "NFT100L15",
    "NFT50SH",
    "NFT500SH",
    "NFT500MULCINDMFG50_30_20",
    "NFT500MULCINFS50_30_20",
    "NFTSMEEMG",
    "NFTAUTO",
    "NFTBANK",
    "NFTFINSERV",
    "NFTFINSERV25_50",
    "NFTFINSERVEB",
    "NFTFMCG",
    "NFTHLTC",
    "NFTIT",
    "NFTMEDIA",
    "NFTMETAL",
    "NFTPHARMA",
    "NFTPVTB",
    "NFTPSUB",
    "NFTREAL",
    "NFTCD",
    "NFTOG",
    "NFTMSFS",
    "NFTMSHC",
    "NFTMSITTEL",
    "NFT50USD",
    "NFTVIX",]


export const Gnft113names = [
    "DATE",
    "GNFTN50",
    "GNFT100",
    "GNFT200",
    "GNFTTTLMAR",
    "GNFT500",
    "GNFT500MC50_25_25",
    "GNFT500LGMSEQLCAPWTD",
    "GNFT50",
    "GNFTMC150",
    "GNFTMC50",
    "GNFTMCSEL",
    "GNFTMC100",
    "GNFTSC250",
    "GNFTSC50",
    "GNFTFSC100",
    "GNFTMC250",
    "GNFTLMC250",
    "GNFTMSC400",
    "GNFT100EQLWGT",
    "GNFT100LVLT30",
    "GNFT50A",
    "GNFT50FPR",
    "GNFT50FTR",
    "GNFT200MOM30",
    "GNFT200AL30",
    "GNFT100AL30",
    "GNFTAL50",
    "GNFTALVLT30",
    "GNFTAQLTLVLT30",
    "GNFTAQLTVLLVLT30",
    "GNFTDO50",
    "GNFTGRTHSEC15",
    "GNFTHBETA50",
    "GNFTLVLT50",
    "GNFTT10EQLWGT",
    "GNFT100QLT30",
    "GNFTMC150MOM50",
    "GNFT500MOM50",
    "GNFTMC150QLT50",
    "GNFTSC250QLT50",
    "GNFTMSC400MOMQLT100",
    "GNFTSC250MOMQLT100",
    "GNFTQLTLVLT30",
    "GNFT50DIVPNT",
    "GNFT50EW",
    "GNFT50PR1XINVS",
    "GNFT50PR2XLVG",
    "GNFT50TR1XINVS",
    "GNFT50TR2XLVG",
    "GNFT50VL20",
    "GNFT200VL30",
    "GNFT500VL50",
    "GNFT500EQLWGT",
    "GNFT200QLT30",
    "GNFT50SRTDURDEBTDYNP_B",
    "GNFT50SRTDURDEBTDYNP_E",
    "GNFTEQTSAV",
    "GNFTCORPGRPIABG",
    "GNFTCOMM",
    "GNFTCH",
    "GNFTCPSE",
    "GNFTENG",
    "GNFTEVNAAMT",
    "GNFTHOUS",
    "GNFT100ESG",
    "GNFT100EESG",
    "GNFT100ESGSL",
    "GNFTCONS",
    "GNFTDEF",
    "GNFTINDDIG",
    "GNFTINDMFG",
    "GNFTINDTR",
    "GNFTINFS",
    "GNFTINDCORPGRPIMG",
    "GNFTMCL15",
    "GNFTMSINDCON",
    "GNFTMNC",
    "GNFTMOB",
    "GNFTPSE",
    "GNFTRI",
    "GNFTNCC",
    "GNFTSERSEC",
    "GNFTSH25",
    "GNFTINDCORPGRPITG",
    "GNFTINDCORPGRPITG25PC",
    "GNFTTRANSLOG",
    "GNFT100L15",
    "GNFT50SH",
    "GNFT500SH",
    "GNFT500MULCINDMFG50_30_20",
    "GNFT500MULCINFS50_30_20",
    "GNFTSMEEMG",
    "GNFTAUTO",
    "GNFTBANK",
    "GNFTFINSERV",
    "GNFTFINSERV25_50",
    "GNFTFINSERVEB",
    "GNFTFMCG",
    "GNFTHLTC",
    "GNFTIT",
    "GNFTMEDIA",
    "GNFTMETAL",
    "GNFTPHARMA",
    "GNFTPVTB",
    "GNFTPSUB",
    "GNFTREAL",
    "GNFTCD",
    "GNFTOG",
    "GNFTMSFS",
    "GNFTMSHC",
    "GNFTMSITTEL",
    "GNFT50USD",
    "GNFTVIX",]